module.exports = __webpack_public_path__ + "img/modeka_speed_tech_schwarz-rot_ml_006.8930ec7d.jpg";